import type {
  Issue2faSetupInfoViewModel,
  PasswordPolicyViewModel,
} from "../../../api/axcloud";

/** 二要素認証のステータス */
export type TwoFactorStatus =
  | "idle"
  | "loading"
  | "failed"
  | "enabling"
  | "disabling";

/** セキュリティ関連の状態 */
export interface SecurityState {
  /** パスワードポリシー */
  passwordPolicy?: PasswordPolicyViewModel | null;
  /** 二要素認証が有効かどうか */
  twoFactorEnabled?: boolean | null;
  /** 二要素認証の設定情報 */
  twoFactorSetupInfo?: Issue2faSetupInfoViewModel | null;
  /** 二要素認証APIの処理状態 */
  twoFactorStatus?: TwoFactorStatus;
}

/** 初期状態 */
export const initialState: SecurityState = {
  passwordPolicy: undefined,
  twoFactorEnabled: null,
  twoFactorSetupInfo: null,
  twoFactorStatus: "idle",
};
